import React from "react";
import styles from "./styles/EnablePerm.module.css"
import { useEffect } from "react";

function PaymentSuccess({OnClose, title='Done!', subtitle='Subscription was created succesfully!', button='Close'}){
    
    useEffect(() => {
        document.documentElement.style.overflow = "hidden";
        return () => {
            document.documentElement.style.overflowY = "auto";
        };
    }, []);
    
    return (
        <div className={styles.background} onClick={OnClose}>
            <div onClick={(e)=>{e.stopPropagation()}} className={styles.main_box} >
                <div  onClick={OnClose} className={styles.close_logo}/>
                <div className={styles.title}>{title}</div>
                <div className={styles.title1}>{subtitle}</div>

                {button &&
                    <div className={styles.footer}>
                        <div onClick={OnClose} className={styles.bluebutton}>{button}</div>
                    </div>
                }
            </div>
        </div>
    )

}
export {PaymentSuccess};